import {
  Box,
  Button,
  Card,
  CardBody,
  CardHeader,
  Checkbox,
  Flex,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Switch,
  Text,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react';
import Pagination from 'components/Pagination/Pagination';
import { ModalType } from 'constants/common';
import { useEffect, useMemo, useRef, useState } from 'react';
import { CookieStorage } from 'utils/cookie-storage';
import CreateBrandingModel from './components/CreateBrandingModal';
import { useQueryGetListBranding } from 'services/branding';
import BrandingTable from './components/Table';
import { Select } from 'chakra-react-select';

function Branding() {
  const textColor = useColorModeValue('gray.700', 'white');
  const [searchTitle, setSearchTitle] = useState('');
  const [sizeBranding, setSizeBranding] = useState(null);
  const [filter, setFilter] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isActive, setIsActive] = useState({ label: 'Tất cả trạng thái', value: undefined });
  const defaultOptionIsActive = [
    {
      label: 'Tất cả trạng thái',
      value: undefined,
    },
    {
      label: 'Kích hoạt',
      value: true,
    },
    {
      label: 'Không kích hoạt',
      value: false,
    },
  ];

  useEffect(() => {
    if (!CookieStorage.isAuthenticated()) {
      return history.push('/auth/sign-in');
    }
  }, []);

  const { isOpen: isCreateModalOpen, onOpen: onOpenCreateModal, onClose: onCloseCreateModal } = useDisclosure();
  const { isOpen: isChangeStatusModalOpen, onOpen: onOpenChangeStatusModal, onClose: onCloseChangeStatusModal } = useDisclosure();
  const openModal = useMemo(
    () => ({
      [ModalType.Add]: onOpenCreateModal,
      [ModalType.ChangeStatus]: onOpenChangeStatusModal,
    }),
    [onOpenCreateModal, onOpenChangeStatusModal]
  );
  const closeModal = useMemo(
    () => ({
      [ModalType.Add]: onCloseCreateModal,
      [ModalType.ChangeStatus]: onCloseChangeStatusModal,
    }),
    [onCloseCreateModal, onCloseChangeStatusModal]
  );

  const handleSearch = () => {
    setFilter({
      ...filter,
      searchTitle: searchTitle,
      isActive: isActive.value,
    });
  };

  const handleReset = () => {
    setFilter({
      pageIndex: 0,
      pageSize: 10,
    });
    setSearchTitle('');
    setIsActive(defaultOptionIsActive[0]);
  };
  const handleUpdateItem = (size, modalType) => {
    openModal?.[modalType]?.();
    setSizeBranding(size);
  };
  const handelCloseModal = modalType => {
    closeModal?.[modalType]?.();
    setSizeBranding(null);
  };
  const { data: brandingData, refetch } = useQueryGetListBranding(
    { ...filter, searchKeyword: filter.searchTitle, isActive: filter.isActive },
    { enabled: CookieStorage.isAuthenticated() }
  );

  return (
    <Flex direction="column" pt={{ base: '120px', md: '75px', lg: '100px' }}>
      <Card p="16px" mb="24px" bg="#fff">
        <CardHeader p="12px 5px" mb="12px">
          <Flex justifyContent={'space-between'}>
            <Flex direction={'column'}>
              <Flex direction="column" gap={'30px'}>
                <Text fontSize="xl" color={textColor} fontWeight="bold">
                  Danh sách Branding
                </Text>
              </Flex>
              <Flex justifyContent={'space-between'} alignItems={'end'} gap={'10px'} mt={'20px'}>
                <Stack>
                  <Flex alignItems={'center'} gap={'20px'} flexWrap={{ base: 'wrap', md: 'nowrap' }}>
                    <FormControl minWidth={{ base: 'full', sm: '300px' }}>
                      <FormLabel>Tìm kiếm</FormLabel>
                      <Input value={searchTitle} onChange={e => setSearchTitle(e.target.value)} />
                    </FormControl>
                    <FormControl>
                      <FormLabel>Trạng thái</FormLabel>
                      <Select
                        value={isActive}
                        options={defaultOptionIsActive}
                        onChange={e => {
                          setIsActive(e);
                        }}
                      ></Select>
                    </FormControl>
                    <Button px="20px" maxH="40px" alignSelf={'end'} onClick={handleReset}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Cài lại
                      </Text>
                    </Button>
                    <Button px="20px" variant="primary" maxH="40px" alignSelf={'end'} onClick={handleSearch}>
                      <Text fontSize="md" fontWeight="bold" cursor="pointer">
                        Tìm kiếm
                      </Text>
                    </Button>
                  </Flex>
                </Stack>
              </Flex>
            </Flex>
            <Flex alignItems={'start'} gap={4}>
              <Button bg="#3182ce" color="#fff" _hover={{ bg: '#67a1d7' }} onClick={onOpenCreateModal}>
                <Text fontSize="md" fontWeight="bold" cursor="pointer">
                  Thêm
                </Text>
              </Button>
            </Flex>
          </Flex>
        </CardHeader>
        <CardBody overflowX="auto">
          <Stack overflow={'auto'}>
            <BrandingTable brandingData={brandingData?.data || []} handleUpdateItem={handleUpdateItem} refetch={refetch} />
          </Stack>
          <Flex justifyContent={'flex-end'}>
            <Pagination
              page={brandingData?.pagination?.page}
              pageLength={brandingData?.pagination?.pageSize}
              totalRecords={brandingData?.pagination?.count}
              onPageChange={(page, pageLength) => {
                setFilter({
                  ...filter,
                  pageSize: pageLength,
                  pageIndex: page - 1,
                });
              }}
            />
          </Flex>
        </CardBody>
      </Card>
      {isCreateModalOpen && (
        <CreateBrandingModel brandingDetail={sizeBranding} isOpen={isCreateModalOpen} onClose={handelCloseModal} refetch={refetch} />
      )}
    </Flex>
  );
}
export default Branding;
